import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { CommissionPayout, CommissionPayoutCreate, CommissionPayoutFilter } from '../data/commissionPayout';

export function createCommissionPayoutService(client: AxiosInstance) {
  return createCrudService<CommissionPayout, CommissionPayoutCreate, CommissionPayoutFilter>(
    client,
    '/accounting/CommissionPayout',
    'id',
  );
}

export type CommissionPayoutService = CrudService<CommissionPayout, CommissionPayoutCreate, CommissionPayoutFilter>;
